export class PlayNowButton {
    constructor(selector) {
        selector = selector || '.play-now-btn';
        this.initlialiseSelectors(selector);
        this.attachListeners();
    }

    initlialiseSelectors(selector) {
        this._element = jQuery(selector);
        this._createAccountPopup = jQuery('.create-account-gate-popup');
    }

    attachListeners() {
        this.onClick();
        this.onShowCreateAccount();
        this.onCloseCreateAccount();
        this.onRedemptionCodeCheckboxChange();
    }

    onClick() {
        this._element.on('click', (event) => {
            event.stopImmediatePropagation();
            event.preventDefault();
            jQuery.cookie("avatarId", null);
            if (jQuery.cookie("authorization_token") === undefined) {
                var e = jQuery.Event('show-create-account');
                jQuery("body").trigger(e);
                e.preventDefault();
            } else {
                window.top.location.href = '/' + document.documentElement.lang + '/game/play';
            }
        })
    }

    onShowCreateAccount() {
        const createAccountPopup = this._createAccountPopup;
        jQuery("body").on('show-create-account', function () {
            createAccountPopup.css({
                "display": "block"
            });
        });
    }

    onCloseCreateAccount() {
        const hideAllErrorTips = this.hideAllErrorTips;
        jQuery(".create-account-gate-popup .pop-close-btn").on('click', function (event) {
            var $popupContainer = jQuery(event.target).closest('.popup-container');
            $popupContainer.css({ "display": "none" });
            hideAllErrorTips();
            $popupContainer.children("input[type=checkbox]").attr('checked', false);
            $popupContainer.children(".code-box").css({ "display": "none" });
        });
    }

    hideAllErrorTips() {
        jQuery('error-tip').css({ "display": "none" });
        jQuery("input[type=text], input[type=password]").removeClass("invalid");
    }

    onRedemptionCodeCheckboxChange() {
        jQuery('input[name=have_code]').change(function () {
            jQuery(this).parents('form.login-form').find(".redemption-code-group").removeClass('floating-label').slideToggle(300);
            jQuery(this).parents('form.login-form').find('input[type=text].redemption-code').val('');
        });
    }

    static setup(selector) {
        new PlayNowButton(selector);
    }
}